import { Icon } from '@aibees/shared/components';
import { Box, Dialog, IconButton, Typography } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { TestimonialVideoModalProps as Props } from './types';

export const TestimonialVideoModal = memo(({ testimonial, onClose }: Props) => {
  const open = !!testimonial;
  const embedSrc = testimonial
    ? `https://www.youtube.com/embed/${testimonial.videoId}?autoplay=1${
        testimonial.start ? `&start=${testimonial.start}` : ''
      }`
    : '';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: SX.paper }}
    >
      {testimonial && (
        <>
          <IconButton
            onClick={onClose}
            sx={SX.closeButton}
            aria-label="Close video"
          >
            <Icon name="close" size={18} />
          </IconButton>
          <Box sx={SX.playerWrap}>
            <Box
              component="iframe"
              src={embedSrc}
              title={testimonial.title}
              sx={SX.iframe}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Box>
          <Box sx={SX.meta}>
            <Typography variant="body3" fontWeight={600} mb={0.5}>
              {testimonial.title}
            </Typography>
            <Typography variant="body4" color="grey.400">
              {testimonial.channel} · {testimonial.views} views
            </Typography>
          </Box>
        </>
      )}
    </Dialog>
  );
});

TestimonialVideoModal.displayName = 'TestimonialVideoModal';
